import React, { FC, useMemo } from 'react'
import ControlledRadioGroupInput from 'transfix-form/components/ControlledRadioGroupInput'
import { makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'
import { useIssuePriorityOptions } from '../../../shared/priorityOptions'
import { useIssueTypeFormContext } from '../../hooks/useIssueTypeForm'

const usePrioritiesStyles = makeStyles(theme => ({
  caption: {
    color: brandColors.coolGray5,
    whiteSpace: 'nowrap',
  },
  labels: {
    gap: theme.spacing(2),
    display: 'grid',
    gridTemplateColumns: '1fr 2fr 3fr',
    width: '70%',
  },
}))

const Priorities: FC = () => {
  const classes = usePrioritiesStyles()
  const priorityOptions = useIssuePriorityOptions()
  const { control } = useIssueTypeFormContext()

  const defaultPriorityOptions = useMemo(
    () =>
      priorityOptions.map(option => ({
        ...option,
        id: option.value,
        label: (
          <div className={classes.labels}>
            <Typography variant='body2'>{option.short}</Typography>
            <Typography variant='body2'>{option.notify}</Typography>
            <Typography variant='body2'>{option.escalate}</Typography>
          </div>
        ),
      })),
    [classes.labels, priorityOptions]
  )

  return (
    <>
      <Typography variant='body1'>Priority</Typography>
      <div className={classes.labels}>
        <div />
        <Typography variant='caption' className={classes.caption}>
          notify post-SLA
        </Typography>
        <Typography variant='caption' className={classes.caption}>
          escalate after
        </Typography>
      </div>
      <ControlledRadioGroupInput
        control={control}
        name='defaultPriority'
        options={defaultPriorityOptions}
      />
    </>
  )
}

export default Priorities
